import { useEffect, useState, useRef, ChangeEvent } from "react";
import {
  Box,
  Typography,
  Divider,
  Container,
  Stack,
  SvgIcon,
  TextField,
  Button,
  Grid,
  Checkbox,
  Autocomplete,
  FormControl,
  FormControlLabel,
  CircularProgress,
  Select,
  MenuItem,
  InputAdornment,
  IconButton,
  Modal,
  Skeleton,
  Chip
} from "@mui/material";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { LoadingButton } from "@mui/lab";
import { KeyboardBackspace, KeyboardArrowLeft, KeyboardArrowRight, SettingsPowerTwoTone } from "@mui/icons-material";
import { object, string, TypeOf, array, number, z, unknown, nullable } from "zod";
import { BrowserView, MobileView, isBrowser, isMobile } from 'react-device-detect';
import {
  SubmitHandler,
  useForm,
  FormProvider,
  Controller,
} from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { toast } from "react-toastify";
import img54 from '../assets/newimg/logo.png';
import {
  useGetPaymentListQuery
} from "../redux/api/paymentApi";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../redux/store";
import { IPaymentDetails, IPaymentHistory } from "../redux/api/types";
import { useGetUserDetailsMutation, useUpdateSettingMutation } from "../redux/api/authApi";
import { logout } from "../redux/features/userSlice";
import {
  useGetUserDetailsQuery
} from "../redux/api/genieApi";
import { useGetPricesDetailsQuery } from "../redux/api/productApi";
import { useSubscribeNewsMutation } from "../redux/api/authApi";
import { useUnSubscribepaymentMutation } from "../redux/api/authApi";
import axios from 'axios';
import { ReactComponent as VerifiedIcon } from '../assets/verified_ico.svg';
import RefreshIcon from '@mui/icons-material/Refresh';
import { usePlanDetailsMutation } from '../redux/api/productApi';
import { getCookie, removeCookie } from "utils/storageUtils";
import InfoIcon from '@mui/icons-material/Info';
import OceshaLogo from '../assets/ocesha_images/ocesha_logo.png';
import CloseIcon from "@mui/icons-material/Close";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import ComingSoonPopup from "components/ComingSoonPopup";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: '#D0D5DD',
    color: 'lightblack',
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: '#161b22',
    color: '#e5e7eb',
  },
  '&:nth-of-type(even)': {
    backgroundColor: '#0d1117',
    color: '#9ca3af',
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));


const updateSettingform = object({
  user_image: string(),
  social_url: string(),
  blog_default: number(),
  email: string(),
  first_name: string(),
  last_name: string()
});

let newErrors = {
  first_name: ''
};

const customInputStyle = {
  color: '#ffffff',
  border: newErrors.first_name ? '1px solid red' : '1px solid #30363d',
  background: 'transparent',
};


export type updateSettingVal = TypeOf<typeof updateSettingform>



const Usersetting = () => {


  // console.log('isMobile=>', isMobile);
  // console.log('MobileView=>', MobileView);

  const navigate = useNavigate();

  const accountInfoRef = useRef<HTMLDivElement>(null);
  const notificationRef = useRef<HTMLDivElement>(null);

  const scrollToAccountInfo = () => {
    accountInfoRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const scrollToNotifications = () => {
    notificationRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  useEffect(() => {
    const loggedIn = localStorage.getItem("logged_in");

    if (loggedIn !== "true") {
      navigate("/signin");
    }
  }, [navigate]);

  const [subscriptionDate, setSubscriptionDate] = useState(null);
  const [planDetails, setPlanDetails] = useState<string | null>(null);
  const [openMenu, setOpenMenu] = useState("Change Password");
  const useremail = localStorage.getItem('user_email') || getCookie('user_email') || '';
  const [userDetails, setUserDetails] = useState<any>('');
  const [updateSettingVal, setUpdateSettingVal] = useState<updateSettingVal>({ user_image: '', social_url: '', blog_default: 0, email: encodeURIComponent(useremail), first_name: '', last_name: '' })
  const [isLoading, setIsLoading] = useState(false);
  const [iscnameLoading, setIsCnameLoading] = useState(false);
  const [userLoading, setUserLoading] = useState(true);


  const [userImage, setUserImage] = useState<File | null>(null);
  const [userImageUrl, setUserImageUrl] = useState('');
  const [socialUrl, setSocialUrl] = useState('');
  const [voiceName, setVoiceName] = useState('');
  const [voiceFiles, setVoiceFiles] = useState<File[]>([]);
  const [voiceFileError, setVoiceFileError] = useState("");
  const [blogDefault, setBlogDefault] = useState(true);
  const [name, setName] = useState('');
  const [lastName, setLastName] = useState('');
  const userEditedName = useRef(false); // track if user manually changed name
  const [email, setEmail] = useState('');
  const [getUserDetailsMutation] = useGetUserDetailsMutation();
  const [isChecked, setIsChecked] = useState(0);
  const [cnameRec, setCnameRec] = useState<any>();
  const [cnameDet, setCnameDet] = useState<any>();
  const [cancellingLoader, setCancellingLoader] = useState<boolean>(false);
  const [successCancelSubscription, setSuccessCancelSubscription] = useState(false);
  const [getuserPlanDetails] = usePlanDetailsMutation();
  const [userplanDetails, setuserPlanDetails] = useState<any>();
  const [upgradeModal, setUpgradeModal] = useState<boolean>(false);
  const [domainName, setDomainName] = useState<any>();
  const [imagePreview, setImagePreview] = useState<any>();
  const [comingSoonOpen, setComingSoonOpen] = useState(false);
  const [popupContent, setPopupContent] = useState({
    title: "",
    description: "",
  });

  // Lead Capture
  const [collectName, setCollectName] = useState(true);
  const [collectEmail, setCollectEmail] = useState(true);
  const [collectSource, setCollectSource] = useState(true);

  // Notifications
  const [notifNewMessage, setNotifNewMessage] = useState(true);
  const [notifNewLead, setNotifNewLead] = useState(true);
  const [notifWeeklySummary, setNotifWeeklySummary] = useState(true);

  // Appearance
  const [theme, setTheme] = useState<'dark' | 'light'>(
    (localStorage.getItem('app_theme') as 'dark' | 'light') || 'dark'
  );

  // Security - Change Password
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [currentPassword, setCurrentPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordLoading, setPasswordLoading] = useState(false);

  // Data & Privacy
  const [exportLoading, setExportLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);

  // Edit Profile panel (Display Name, Bio, Custom URL)
  const [editProfileOpen, setEditProfileOpen] = useState<string | false>(false);
  const [editDisplayName, setEditDisplayName] = useState('');
  const [editBio, setEditBio] = useState('');
  const [editCustomUrl, setEditCustomUrl] = useState('');
  const [editProfileLoading, setEditProfileLoading] = useState(false);
  const isGoogleUser = userDetails?.provider === 'google';

  const validateForm = () => {
    // Name is optional - always return valid
    return true;
  };


  const dispatch = useAppDispatch();

  const handleLogout = () => {
    localStorage.setItem("logged_in", "false");
    //console.log("loggedin:" + localStorage.getItem("logged_in"));
    dispatch(logout());
    var module = localStorage.getItem("module");
    console.log("module111...." + module);
    if (module == process.env.REACT_APP_MAIN_PRODUCT_NAME)
      navigate("/Anycode_landing");
    else
      navigate("/");
    toast.success("Logout success");
    localStorage.removeItem("payment");
    localStorage.removeItem("msg");
    localStorage.removeItem("complexity");
    localStorage.removeItem("module");
    localStorage.removeItem("subscription_level");
    localStorage.removeItem("free_plan");
    localStorage.removeItem("user_email");
    // localStorage.removeItem("userRole");

    removeCookie('user_email');
    localStorage.clear();
  }

  const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, checked } = e.target;
    const checkedString = checked ? 1 : 0;
    setUpdateSettingVal(prevState => ({
      ...prevState,
      [name]: checkedString,
    }));
  };

  const openComingSoon = (
    title: string,
    description: string
  ) => {
    setPopupContent({
      title,
      description,
    });

    setComingSoonOpen(true);
  };

  const fetchData = async () => {
    try {
      setUserLoading(true);

      const response = await getUserDetailsMutation({ email: useremail, filter: '', start_date: '', end_date: '' });

      if ('data' in response) {
        const details = response.data.data;
        setUserDetails(details);

        // Use first_name / last_name directly if available, else split 'name' field
        if (details?.first_name || details?.last_name) {
          setName(details.first_name || '');
          setLastName(details.last_name || '');
        } else {
          const rawFull = (details?.name || '').trim();
          const parts = rawFull.split(' ');
          setName(parts[0] || '');
          setLastName(parts.slice(1).join(' ') || '');
        }
        console.log('userdetails from usersetting=>', details);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setUserLoading(false);
    }
  }

  const fetchPlanDatas = async () => {
    try {
      const response = await getuserPlanDetails({ email: useremail, campaignid: /* campIdFrEdit || localStorage.getItem('IdChangingMode') ||  */'' });
      if ('data' in response) {

        setuserPlanDetails(response.data.data);
        console.log('plan details***=>', response.data.data);
      }
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    fetchPlanDatas();
  }, []);

  useEffect(() => {
    if (userDetails?.profile_id) {
      setSocialUrl(
        `${window.location.origin}/profile/${userDetails.profile_id}`
      );
    }
  }, [userDetails?.profile_id]);

  const handleImageChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];

      setUserImage(file);

      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    }
  };

  const handleCheckBoxClick = (event: React.ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked ? 1 : 0);
  }

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const files = Array.from(e.target.files || []);

    const validFiles = files.filter((file) => {
      const isWavType =
        file.type === "audio/wav" || file.type === "audio/x-wav";
      const isWavName = file.name.toLowerCase().endsWith(".wav");
      return isWavType || isWavName;
    });

    const invalidCount = files.length - validFiles.length;

    // Show error but DO NOT clear previous valid files
    if (invalidCount > 0) {
      toast.error("Only WAV files are allowed. Invalid files ignored.");
    }

    // Append new valid files (not replace)
    setVoiceFiles((prev) => {
      // avoid duplicates (optional but better)
      const newFiles = validFiles.filter(
        (file) => !prev.some((f) => f.name === file.name)
      );
      return [...prev, ...newFiles];
    });

    // reset input
    e.target.value = "";
  };

  const handleUpdateSetting = async (e: React.FormEvent<HTMLFormElement> | React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    // Check voiceName & voiceFiles dependency
    if (voiceName && voiceFiles.length === 0) {
      toast.error("Please upload at least 3 WAV files for the voice name");
      return;
    }

    if (!voiceName && voiceFiles.length > 0) {
      toast.error("Please enter a voice name");
      return;
    }

    // (Voice file) WAV validation
    if (voiceFiles.length > 0) {
      if (voiceFiles.length < 3) {
        toast.error("Please upload at least 3 WAV files");
        return;
      }

      const invalidFile = voiceFiles.some((file) => {
        const isWavType =
          file.type === "audio/wav" || file.type === "audio/x-wav";
        const isWavName = file.name.toLowerCase().endsWith(".wav");
        return !(isWavType || isWavName);
      });

      if (invalidFile) {
        toast.error("Only WAV files are allowed");
        return;
      }
    }

    // Build two separate FormData:
    // 1. Text-only fields (no user_image) — avoids backend 500 when no file
    // 2. Image-only (if user selected a new photo)
    const fullName = `${name.trim()} ${lastName.trim()}`.trim();

    let isFormValid = validateForm();
    if (isFormValid) {
      setIsLoading(true);

      // --- Text fields FormData (never includes user_image) ---
      const formData = new FormData();
      formData.append('first_name', name.trim());
      formData.append('last_name', lastName.trim());
      formData.append('email', useremail);
      formData.append('social_url', socialUrl);
      formData.append('blog_default', blogDefault ? '1' : '0');
      formData.append('auto_publish', isChecked ? `${isChecked}` : '0');

      try {
        const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

        // Step 1: Update text fields
        const response = await axios.post(apiUrl + '/api/auth/updateUserSettings', formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        // Step 2: Update image separately only if user picked a new photo
        if (userImage && response.data.status == "success") {
          const imgFormData = new FormData();
          imgFormData.append('first_name', name.trim());
          imgFormData.append('last_name', lastName.trim());
          imgFormData.append('email', useremail);
          imgFormData.append('user_image', userImage);
          imgFormData.append('blog_default', blogDefault ? '1' : '0');
          imgFormData.append('auto_publish', isChecked ? `${isChecked}` : '0');
          try {
            const imgRes = await axios.post(apiUrl + '/api/auth/updateUserSettings', imgFormData, {
              headers: { 'Content-Type': 'multipart/form-data' },
            });
            if (imgRes.data.user_image) {
              const randomNumber = Math.random();
              const newImg = imgRes.data.user_image + '?' + randomNumber;
              setUserImageUrl(newImg);
              localStorage.setItem('UpdateduserImage', newImg);
              window.dispatchEvent(new Event('storage'));
            }
          } catch (_imgErr) {
            console.error('Image upload error:', _imgErr);
          }
        }
        if (response.data.status == "success") {
          toast.success(response.data.message);

          // 1. Immediately set name fields from what user typed
          const savedFirst = name.trim();
          const savedLast = lastName.trim();
          setName(savedFirst);
          setLastName(savedLast);

          // 2. Update localStorage + notify header
          localStorage.setItem('user_name', fullName);
          window.dispatchEvent(new Event('storage'));

          // instant header refresh
          window.dispatchEvent(new Event("profileUpdated"));

          // 4. Keep UI state with exactly what user typed.
          // NOTE: Do NOT call getUserDetailsMutation here — backend does not reliably
          // return updated last_name, so we preserve user-typed values in state directly.
          userEditedName.current = false;
          setName(savedFirst);
          setLastName(savedLast);
          // Also update userDetails object so Display Name / Authority Page shows correct value
          setUserDetails((prev: any) => ({ ...prev, first_name: savedFirst, last_name: savedLast }));

          // if having voicename value
          if (voiceName) {
            try {
              const res = await axios.post(`${apiUrl}/api/auth/update_digitial_twin_voice?email=${useremail}&voice_name=${voiceName}`);
              console.log('voice name updating res=>', res);
              toast.success(res?.data?.message);
            } catch (err: any) {
              console.error('Error updating voice:', err);
            }
          }

          // TRAIN VOICE (UPLOAD FILES)
          if (voiceName && voiceFiles.length >= 3) {
            try {
              const formDataVoice = new FormData();

              formDataVoice.append("voice_name", voiceName);

              voiceFiles.forEach((file) => {
                formDataVoice.append("files", file);
              });

              const ttsUrl: string = process.env.REACT_APP_TTS_ENDPOINT || '';
              const res = await axios.post(
                `${ttsUrl}/train_voice`,
                formDataVoice,
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                  },
                }
              );
              console.log('voice training res=>', res);
              if (res?.data?.status === 'voice_trained') {
                toast.success("Voice trained successfully");
              } else {
                toast.error('Something went wrong, please try again later!');
              }
            } catch (error) {
              console.error("Voice upload error:", error);
              toast.error("Voice training failed");
            }
          }
        }
        else {
          toast.error("Somethng went wrong..")
          setIsLoading(false);
        }
        console.log(response.data);
      } catch (error) {
        console.error('Error updating user settings:', error);
        setIsLoading(false);
      } finally {
        setIsLoading(false);
      }

    }

  };

  useEffect(() => {
    fetchData();
  }, [])


  useEffect(() => {

    if (!userDetails) return;

    // Populate First Name & Last Name from API response (userDetails always has correct merged values)
    if (userDetails.first_name !== undefined || userDetails.last_name !== undefined) {
      setName(userDetails.first_name || "");
      setLastName(userDetails.last_name || "");
    } else if (userDetails.name) {
      const parts = (userDetails.name as string).trim().split(" ");
      setName(parts[0] || "");
      setLastName(parts.slice(1).join(" ") || "");
    }

    setEmail(userDetails.email);
    // setSocialUrl((userDetails.social_url != "undefined" && userDetails.social_url) ? userDetails.social_url : "");
    setBlogDefault(userDetails.blog_default);
    setUserImageUrl(userDetails.user_image);
    console.log('user profile image res=>', userDetails?.user_image);
    // localStorage.setItem('UpdateduserImage', userImageUrl);
    setIsChecked(userDetails.auto_publish);
    console.log(userDetails);

    // Lead Capture
    if (userDetails.collect_name !== undefined) setCollectName(!!userDetails.collect_name);
    if (userDetails.collect_email !== undefined) setCollectEmail(!!userDetails.collect_email);
    if (userDetails.collect_source !== undefined) setCollectSource(!!userDetails.collect_source);

    // Notifications
    if (userDetails.notif_new_message !== undefined) setNotifNewMessage(!!userDetails.notif_new_message);
    if (userDetails.notif_new_lead !== undefined) setNotifNewLead(!!userDetails.notif_new_lead);
    if (userDetails.notif_weekly_summary !== undefined) setNotifWeeklySummary(!!userDetails.notif_weekly_summary);
  }, [userDetails]);

  useEffect(() => {
    if (userImageUrl) {
      localStorage.setItem("UpdateduserImage", userImageUrl);
    }
  }, [userImageUrl]);

  const fetchCnameRec = async () => {
    setIsCnameLoading(true);
    try {
      const domain = window.location.host;
      const url = new URL(domain);
      const hostname = 'content'
      console.log(hostname + '.' + window.location.host);

      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const response = await axios.post(apiUrl + `/api/prompts/getcnameentries?email=${encodeURIComponent(useremail)}&domain=${hostname + '.' + domain}&hostname=${hostname}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      console.log('Cname Record:', response.data);
      setCnameDet(response.data);
      setCnameRec(response.data.cnamerecords);
    } catch (error) {
      console.log('Error fetching cname rec:', error);
    } finally {
      setIsCnameLoading(false);
    }
  }

  useEffect(() => {
    if (userplanDetails?.plan_name === 'Enterprise') {
      fetchCnameRec();
    }
  }, []);

  const handleCopyName = (name: string) => {
    navigator.clipboard.writeText(name).then(() => {
      toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
        style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
      });

    })
  }

  const handleCopyVal = (value: string) => {
    navigator.clipboard.writeText(value).then(() => {
      toast.success('Data has been copied to your clipboard!\r\n\r\nNote: You may need to click "Allow" when prompted by your browser to enable clipboard access for www.ocesha.com.', {
        style: { whiteSpace: 'pre-line', width: '300px' }, autoClose: 15000,
      });
    })
  }

  const handleChangePayMethodClick = async () => {
    // localStorage.setItem('ChangepayMode', 'true');
    // localStorage.setItem('IdChangingMode', campIdFrEdit);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const response = await axios.post(apiUrl + `/api/subscription/change_payment_method?email=${useremail}`, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      if (response.data.status === 'success') {
        window.open(response.data.portal_url, '_blank');
      }
    } catch (error) {
      console.log('Error changing payment method', error);
    }
  }

  const handleCancelSubscriptionClick = async () => {
    setCancellingLoader(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const response = await axios.post(apiUrl + `/api/subscription/Cancel_Subscription?email=${useremail}`, {
        headers: {
          'content-type': 'multipart/form-data',
        }
      });
      if (response.data.status === 'success') {
        setSuccessCancelSubscription(true);
        toast.success('Cancelled Subscription!');
      }
    } catch (error) {
      toast.error('Error cancelling subscription');
      console.log('Error cancelling subscription', error);
    } finally {
      setCancellingLoader(false);
    }
  };

  useEffect(() => {
    return () => {
      if (imagePreview) {
        URL.revokeObjectURL(imagePreview);
      }
    };
  }, [imagePreview]);

  // ── Appearance ──
  const handleThemeChange = (selected: 'dark' | 'light') => {
    setTheme(selected);
    localStorage.setItem('app_theme', selected);
    toast.success(`Theme changed to ${selected}`);
  };

  // ── Lead Capture & Notifications: save via updateUserSettings ──
  const saveToggleSetting = async (field: string, value: boolean) => {
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const fd = new FormData();
      fd.append('email', useremail);
      fd.append('first_name', name.trim());    // required field
      fd.append('last_name', lastName.trim()); // required field
      fd.append('auto_publish', isChecked ? `${isChecked}` : '0');
      fd.append('blog_default', blogDefault ? '1' : '0');
      fd.append('social_url', socialUrl || '');
      fd.append(field, value ? '1' : '0');
      await axios.post(apiUrl + '/api/auth/updateUserSettings', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
    } catch (err) {
      console.error(`Error saving ${field}:`, err);
      toast.error('Failed to save setting');
    }
  };

  // ── Security: Change Password ──
  const handleChangePassword = async () => {
    if (!currentPassword || !newPassword || !confirmPassword) {
      toast.error('Please fill all password fields');
      return;
    }
    if (newPassword !== confirmPassword) {
      toast.error('New password and confirm password do not match');
      return;
    }
    if (newPassword.length < 6) {
      toast.error('Password must be at least 6 characters');
      return;
    }
    setPasswordLoading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const response = await axios.post(apiUrl + '/api/auth/updatePass', {
        email: useremail,
        oldPassword: currentPassword,
        password: newPassword,
        passwordConfirm: confirmPassword,
      });
      if (response.data.status === 'success') {
        toast.success('Password updated successfully');
        setShowPasswordModal(false);
        setCurrentPassword('');
        setNewPassword('');
        setConfirmPassword('');
      } else {
        toast.error(response.data.message || 'Failed to update password');
      }
    } catch (err) {
      console.error('Error updating password:', err);
      toast.error('Failed to update password');
    } finally {
      setPasswordLoading(false);
    }
  };

  // ── Data & Privacy: Export data ──
  const handleExportData = async () => {
    setExportLoading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';

      // Get userid from userDetails (already fetched on page load)
      const userid = userDetails?._id || userDetails?.id || userDetails?.userid || userDetails?.user_id || '';
      console.log('userDetails for export =>', userDetails);
      console.log('userid =>', userid);

      if (!userid) {
        toast.error('User ID not found. Please refresh and try again.');
        return;
      }

      // Step 1: fetch user's blogs using userid
      const blogsRes = await axios.get(
        `${apiUrl}/api/prompts/listBlogsByUserID?userid=${encodeURIComponent(userid)}`
      );
      console.log('listBlogsByUserID raw response =>', blogsRes.data);

      // Handle all possible response shapes
      let blogs: any[] = [];
      if (Array.isArray(blogsRes.data)) {
        blogs = blogsRes.data;
      } else if (Array.isArray(blogsRes.data?.data)) {
        blogs = blogsRes.data.data;
      } else if (Array.isArray(blogsRes.data?.blogs)) {
        blogs = blogsRes.data.blogs;
      } else if (Array.isArray(blogsRes.data?.result)) {
        blogs = blogsRes.data.result;
      }

      console.log('parsed blogs =>', blogs);

      if (!blogs.length) {
        toast.error('No blogs found to export');
        return;
      }

      // Extract IDs — check all common field names
      const promptIds = blogs
        .map((b: any) => b._id || b.id || b.prompt_id || b.promptId)
        .filter(Boolean)
        .join(',');

      console.log('prompt_ids to export =>', promptIds);

      if (!promptIds) {
        toast.error('Could not read blog IDs');
        return;
      }

      // Step 2: export CSV with prompt_ids
      const response = await axios.get(
        `${apiUrl}/api/prompts/export_seo_csv?prompt_ids=${encodeURIComponent(promptIds)}`,
        { responseType: 'blob' }
      );
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'my_data.csv');
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      toast.success('Data exported successfully');
    } catch (err) {
      console.error('Export error:', err);
      toast.error('Failed to export data');
    } finally {
      setExportLoading(false);
    }
  };

  // ── Data & Privacy: Delete account ──
  const handleDeleteAccount = async () => {
    setDeleteLoading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const response = await axios.get(
        `${apiUrl}/api/auth/deactivate_user?email=${encodeURIComponent(useremail)}`
      );
      if (response.data.status === 'success') {
        toast.success('Account deleted successfully');
        setShowDeleteConfirm(false);
        handleLogout();
      } else {
        toast.error(response.data.message || 'Failed to delete account');
      }
    } catch (err) {
      console.error('Delete account error:', err);
      toast.error('Failed to delete account');
    } finally {
      setDeleteLoading(false);
    }
  };

  // ── Edit Profile (Authority Page): save Display Name, Bio, Custom URL ──
  const handleEditProfileSave = async () => {
    setEditProfileLoading(true);
    try {
      const apiUrl: string = process.env.REACT_APP_SERVER_ENDPOINT || '';
      const fd = new FormData();
      fd.append('email', useremail);
      // Always send current values; only the edited field has a new value
      const saveDisplayName = editProfileOpen === 'displayName' ? editDisplayName.trim() : [name, lastName].filter(Boolean).join(' ');
      const saveBio = editProfileOpen === 'bio' ? editBio.trim() : (userDetails?.bio || '');
      const saveUrl = editProfileOpen === 'customUrl' ? editCustomUrl.trim() : (socialUrl || '');
      const saveFirstName = editProfileOpen === 'displayName' ? (editDisplayName.trim().split(' ')[0] || '') : name.trim();
      const saveLastName = editProfileOpen === 'displayName' ? (editDisplayName.trim().split(' ').slice(1).join(' ') || '') : lastName.trim();
      fd.append('first_name', saveFirstName);
      fd.append('last_name', saveLastName);
      fd.append('bio', saveBio);
      fd.append('social_url', saveUrl);
      fd.append('blog_default', blogDefault ? '1' : '0');
      fd.append('auto_publish', isChecked ? `${isChecked}` : '0');
      const response = await axios.post(apiUrl + '/api/auth/updateUserSettings', fd, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      if (response.data.status === 'success') {
        toast.success('Profile updated successfully');
        if (editProfileOpen === 'displayName') {
          const parts = saveDisplayName.split(' ');
          setName(parts[0] || '');
          setLastName(parts.slice(1).join(' ') || '');
        }
        if (editProfileOpen === 'customUrl') setSocialUrl(saveUrl);
        if (editProfileOpen === 'bio') setUserDetails((prev: any) => ({ ...prev, bio: saveBio }));
        setEditProfileOpen(false);
      } else {
        toast.error(response.data.message || 'Failed to update profile');
      }
    } catch (err) {
      console.error('Edit profile error:', err);
      toast.error('Failed to update profile');
    } finally {
      setEditProfileLoading(false);
    }
  };

  return (
    <>
      {/* <div className="body-17-1"> */}

      {/* <div className="container-fluid">
        <div className="row">
          <nav className="navbar navbar-expand-md">
            <div className="container-fluid" style={{ padding: '0% 3%' }}>
              <a className="navbar-brand" href="/">
                <img src={OceshaLogo} className="img-fluid" alt="" />

              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarScroll"
                aria-controls="navbarScroll"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="">
                  <i className="bi bi-list text-white" />
                </span>
              </button>




              <div className="collapse navbar-collapse" id="navbarScroll">
                <ul className="navbar-nav me-auto my-2 my-lg-0 navbar-nav-scroll ms-md-5  gap-4">
                  <li className="nav-item">
                  </li>

                </ul>


                {isMobile ?

                  <div className="d-flex gap-4" role="search" style={{ justifyContent: 'center' }}>
                    <button className="button_leniar px-3"
                      onClick={handleLogout} style={{ fontSize: '13px' }}>Logout</button>
                    <button className="button_leniar px-3"
                      onClick={(e) => { window.history.back(); return false; }} style={{ fontSize: '13px' }}>Go Back</button>
                  </div>
                  : <div className="d-flex gap-4" role="search">
                    <button className="button_leniar px-3"
                      onClick={handleLogout} style={{ fontSize: '13px' }}>Logout</button>
                    <button className="button_leniar px-3"
                      onClick={() => window.history.back()} style={{ fontSize: '13px' }}>Go Back</button>
                  </div>}

              </div>
            </div>
          </nav>
          <hr className="" style={{ color: "rgb(154, 160, 163)" }} />
        </div>
      </div> */}
      <form id="sform" name="sform" onSubmit={handleUpdateSetting}>
        <Box sx={{ padding: isMobile ? '16px' : '24px 32px' }}>

          {/* ── Page Header ── */}
          <Typography variant="h4" fontWeight={700} color="#e5e7eb" sx={{ mb: 0.5 }}>Settings</Typography>
          <Typography variant="body2" color="#9ca3af" sx={{ mb: 3 }}>Manage your account, profile, and preferences.</Typography>

          {/* ── 2-Column Layout ── */}
          <Grid container spacing={3}>

            {/* ══ LEFT COLUMN ══ */}
            <Grid item xs={12} md={7} lg={7}>

              {/* Account Information */}
              <Box ref={accountInfoRef} sx={{ border: '1px solid #21262d', borderRadius: '12px', p: 3, mb: 3, backgroundColor: 'transparent' }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 2.5 }}>
                  <Box sx={{ width: 36, height: 36, borderRadius: '8px', backgroundColor: '#161b22', border: '1px solid #21262d', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Typography sx={{ fontSize: '18px' }}>👤</Typography>
                  </Box>
                  <Box>
                    <Typography fontWeight={600} color="#e5e7eb" variant="subtitle1">Account Information</Typography>
                    <Typography variant="caption" color="#9ca3af">Update your personal information.</Typography>
                  </Box>
                </Box>

                {userLoading ? (
                  <Stack spacing={2}>
                    <Skeleton variant="rectangular" height={48} sx={{ bgcolor: '#21262d', borderRadius: '8px' }} />
                    <Skeleton variant="rectangular" height={48} sx={{ bgcolor: '#21262d', borderRadius: '8px' }} />
                    <Skeleton variant="rectangular" height={48} sx={{ bgcolor: '#21262d', borderRadius: '8px' }} />
                  </Stack>
                ) : (
                  <>
                    {/* First Name + Last Name row */}
                    <Grid container spacing={2} sx={{ mb: 2 }}>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="caption" color="#9ca3af" sx={{ mb: 0.5, display: 'block' }}>First Name</Typography>
                        <TextField
                          InputProps={{ style: customInputStyle }}
                          sx={{ width: '100%', '& .MuiOutlinedInput-root': { backgroundColor: '#0d1117', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
                          type="text"
                          placeholder="First name"
                          value={name}
                          onChange={(e) => { userEditedName.current = true; setName(e.target.value); }}
                        />
                        {newErrors.first_name && <p style={{ color: 'red', fontSize: '12px' }}>{newErrors.first_name}</p>}
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <Typography variant="caption" color="#9ca3af" sx={{ mb: 0.5, display: 'block' }}>Last Name</Typography>
                        <TextField
                          InputProps={{ style: customInputStyle }}
                          sx={{ width: '100%', '& .MuiOutlinedInput-root': { backgroundColor: '#0d1117', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
                          type="text"
                          placeholder="Last name"
                          value={lastName}
                          onChange={(e) => { userEditedName.current = true; setLastName(e.target.value); }}
                        />
                      </Grid>
                    </Grid>

                    {/* Email Address */}
                    <Typography variant="caption" color="#9ca3af" sx={{ mb: 0.5, display: 'block' }}>Email Address</Typography>
                    <TextField
                      InputProps={{ style: customInputStyle, readOnly: true }}
                      sx={{ width: '100%', mb: 2, '& .MuiOutlinedInput-root': { backgroundColor: '#0d1117', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
                      type="text"
                      placeholder="your@email.com"
                      value={email}
                    />

                    {/* Profile Image */}
                    <Typography variant="caption" color="#9ca3af" sx={{ mb: 0.5, display: 'block' }}>Profile Image</Typography>
                    <input
                      id="profile-image-input"
                      type="file"
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={handleImageChange}
                    />
                    {(imagePreview || userImageUrl) ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1 }}>
                        <img
                          src={imagePreview || userImageUrl}
                          alt="Profile"
                          style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', objectPosition: 'center top', border: '2px solid #30363d' }}
                        />
                        <Button
                          variant="outlined"
                          size="small"
                          onClick={() => document.getElementById('profile-image-input')?.click()}
                          sx={{ borderColor: '#30363d', color: '#9ca3af', borderRadius: '8px', textTransform: 'none', fontSize: '12px', '&:hover': { borderColor: '#3b82f6', color: '#3b82f6' } }}
                        >
                          Change Photo
                        </Button>
                      </Box>
                    ) : (
                      <Button
                        variant="outlined"
                        size="small"
                        onClick={() => document.getElementById('profile-image-input')?.click()}
                        sx={{ mb: 1, borderColor: '#30363d', color: '#9ca3af', borderRadius: '8px', textTransform: 'none', fontSize: '12px', '&:hover': { borderColor: '#3b82f6', color: '#3b82f6' } }}
                      >
                        Upload Photo
                      </Button>
                    )}

                    {/* URL */}
                    <Typography variant="caption" color="#9ca3af" sx={{ mb: 0.5, mt: 2, display: 'block' }}>Social URL</Typography>
                    <TextField
                      InputProps={{ readOnly: true, style: customInputStyle }}
                      sx={{ width: '100%', mb: 2, '& .MuiOutlinedInput-root': { backgroundColor: '#0d1117', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
                      type="text"
                      // placeholder={`E.g. https://www.linkedin.com/in/profile_name`}
                      placeholder={`${window.location.origin}/profile/test-123`}
                      value={socialUrl}
                    // onChange={(e) => setSocialUrl(e.target.value)}
                    />

                    <FormControlLabel
                      control={
                        <Checkbox
                          name="blog_default"
                          checked={blogDefault}
                          onChange={(e) => setBlogDefault(e.target.checked)}
                          style={{ color: '#3b82f6' }}
                        />
                      }
                      label={<Typography color="#9ca3af" variant="body2">Use this information on my blogs</Typography>}
                    />

                    {/* Save Changes - right aligned */}
                    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 2 }}>
                      <Button
                        type="button"
                        variant="contained"
                        sx={{ backgroundColor: '#3b82f6', color: '#fff', borderRadius: '8px', px: 3 }}
                        onClick={(e: any) => handleUpdateSetting(e as any)}
                      >
                        {isLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Save Changes'}
                      </Button>
                    </Box>
                  </>
                )}
              </Box>

              {/* Profile on Your Authority Page */}
              <Box sx={{ border: '1px solid #21262d', borderRadius: '12px', p: 3, mb: 3, backgroundColor: 'transparent' }}>
                <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, mb: 2.5 }}>
                  <Box sx={{ width: 36, height: 36, borderRadius: '8px', backgroundColor: '#161b22', border: '1px solid #21262d', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <Typography sx={{ fontSize: '18px' }}>📄</Typography>
                  </Box>
                  <Box>
                    <Typography fontWeight={600} color="#e5e7eb" variant="subtitle1">Profile on Your Authority Page</Typography>
                    <Typography variant="caption" color="#9ca3af">This is how you appear on your Authority Page and Blog.</Typography>
                  </Box>
                </Box>

                {/* ── Display Name row ── */}
                {(() => {
                  const isEditing = editProfileOpen === ('displayName' as any);
                  const displayNameVal = [name, lastName].filter(Boolean).join(' ') || '—';
                  return (
                    <Box sx={{ py: 1.5, borderBottom: '1px solid #21262d' }}>
                      {isEditing ? (
                        <Box>
                          <Typography variant="caption" color="#9ca3af" sx={{ display: 'block', mb: 0.5 }}>Display Name</Typography>
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <TextField
                              fullWidth autoFocus size="small"
                              value={editDisplayName}
                              onChange={(e) => setEditDisplayName(e.target.value)}
                              placeholder="Your full display name"
                              sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#161b22', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#3b82f6' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
                              inputProps={{ style: { color: '#fff' } }}
                            />
                            <Button size="small" variant="contained" onClick={handleEditProfileSave} disabled={editProfileLoading}
                              sx={{ backgroundColor: '#3b82f6', color: '#fff', borderRadius: '8px', textTransform: 'none', minWidth: 64, whiteSpace: 'nowrap' }}>
                              {editProfileLoading ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : 'Save'}
                            </Button>
                            <Button size="small" variant="outlined" onClick={() => setEditProfileOpen(false as any)}
                              sx={{ borderColor: '#30363d', color: '#9ca3af', borderRadius: '8px', textTransform: 'none', minWidth: 64 }}>
                              Cancel
                            </Button>
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', borderRadius: '8px', px: 1, mx: -1, '&:hover': { backgroundColor: '#161b22' }, transition: 'background 0.15s' }}
                          onClick={() => { setEditDisplayName([name, lastName].filter(Boolean).join(' ') || ''); setEditProfileOpen('displayName' as any); }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.5 }}>
                            <Typography sx={{ fontSize: '16px' }}>👤</Typography>
                            <Box>
                              <Typography variant="body2" color="#e5e7eb" fontWeight={500}>Display Name</Typography>
                              <Typography variant="caption" color="#9ca3af">{userLoading ? '...' : displayNameVal}</Typography>
                            </Box>
                          </Box>
                          <Typography variant="caption" color="#3b82f6" sx={{ fontSize: '12px', opacity: 0.7 }}>Edit</Typography>
                        </Box>
                      )}
                    </Box>
                  );
                })()}

                {/* ── Bio row ── */}
                {(() => {
                  const isEditing = editProfileOpen === ('bio' as any);
                  const bioVal = userDetails?.bio || '—';
                  return (
                    <Box sx={{ py: 1.5, borderBottom: '1px solid #21262d' }}>
                      {isEditing ? (
                        <Box>
                          <Typography variant="caption" color="#9ca3af" sx={{ display: 'block', mb: 0.5 }}>Bio</Typography>
                          <TextField
                            fullWidth autoFocus multiline minRows={3}
                            value={editBio}
                            onChange={(e) => setEditBio(e.target.value)}
                            placeholder="Tell visitors about yourself..."
                            sx={{ mb: 1.5, '& .MuiOutlinedInput-root': { backgroundColor: '#161b22', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#3b82f6' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
                            inputProps={{ style: { color: '#fff' } }}
                          />
                          <Box sx={{ display: 'flex', gap: 1, justifyContent: 'flex-end' }}>
                            <Button size="small" variant="outlined" onClick={() => setEditProfileOpen(false as any)}
                              sx={{ borderColor: '#30363d', color: '#9ca3af', borderRadius: '8px', textTransform: 'none' }}>
                              Cancel
                            </Button>
                            <Button size="small" variant="contained" onClick={handleEditProfileSave} disabled={editProfileLoading}
                              sx={{ backgroundColor: '#3b82f6', color: '#fff', borderRadius: '8px', textTransform: 'none' }}>
                              {editProfileLoading ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : 'Save'}
                            </Button>
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', cursor: 'pointer', borderRadius: '8px', px: 1, mx: -1, '&:hover': { backgroundColor: '#161b22' }, transition: 'background 0.15s' }}
                          onClick={() => { setEditBio(userDetails?.bio || ''); setEditProfileOpen('bio' as any); }}>
                          <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 1.5, py: 0.5, flex: 1, minWidth: 0 }}>
                            <Typography sx={{ fontSize: '16px', mt: 0.3 }}>📝</Typography>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography variant="body2" color="#e5e7eb" fontWeight={500}>Bio</Typography>
                              <Typography variant="caption" color="#9ca3af" sx={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden', wordBreak: 'break-word' }}>
                                {userLoading ? '...' : bioVal}
                              </Typography>
                            </Box>
                          </Box>
                          <Typography variant="caption" color="#3b82f6" sx={{ fontSize: '12px', opacity: 0.7, ml: 1, flexShrink: 0, mt: 0.5 }}>Edit</Typography>
                        </Box>
                      )}
                    </Box>
                  );
                })()}

                {/* ── Custom URL row ── */}
                {/* {(() => {
                  const isEditing = editProfileOpen === ('customUrl' as any);
                  const urlVal = socialUrl || '—';
                  return (
                    <Box sx={{ py: 1.5 }}>
                      {isEditing ? (
                        <Box>
                          <Typography variant="caption" color="#9ca3af" sx={{ display: 'block', mb: 0.5 }}>Custom URL</Typography>
                          <Box sx={{ display: 'flex', gap: 1, alignItems: 'center' }}>
                            <TextField
                              fullWidth autoFocus size="small"
                              value={editCustomUrl}
                              onChange={(e) => setEditCustomUrl(e.target.value)}
                              placeholder="E.g. https://www.linkedin.com/in/profile_name"
                              sx={{ '& .MuiOutlinedInput-root': { backgroundColor: '#161b22', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#3b82f6' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
                              inputProps={{ style: { color: '#fff' } }}
                            />
                            <Button size="small" variant="contained" onClick={handleEditProfileSave} disabled={editProfileLoading}
                              sx={{ backgroundColor: '#3b82f6', color: '#fff', borderRadius: '8px', textTransform: 'none', minWidth: 64, whiteSpace: 'nowrap' }}>
                              {editProfileLoading ? <CircularProgress size={14} sx={{ color: '#fff' }} /> : 'Save'}
                            </Button>
                            <Button size="small" variant="outlined" onClick={() => setEditProfileOpen(false as any)}
                              sx={{ borderColor: '#30363d', color: '#9ca3af', borderRadius: '8px', textTransform: 'none', minWidth: 64 }}>
                              Cancel
                            </Button>
                          </Box>
                        </Box>
                      ) : (
                        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', borderRadius: '8px', px: 1, mx: -1, '&:hover': { backgroundColor: '#161b22' }, transition: 'background 0.15s' }}
                          onClick={() => { setEditCustomUrl(socialUrl || ''); setEditProfileOpen('customUrl' as any); }}>
                          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 0.5, flex: 1, minWidth: 0 }}>
                            <Typography sx={{ fontSize: '16px' }}>🔗</Typography>
                            <Box sx={{ flex: 1, minWidth: 0 }}>
                              <Typography variant="body2" color="#e5e7eb" fontWeight={500}>Custom URL</Typography>
                              <Typography variant="caption" color="#9ca3af" sx={{ overflow: 'hidden', textOverflow: 'ellipsis', display: 'block', whiteSpace: 'nowrap' }}>
                                {userLoading ? '...' : urlVal}
                              </Typography>
                            </Box>
                          </Box>
                          <Typography variant="caption" color="#3b82f6" sx={{ fontSize: '12px', opacity: 0.7, ml: 1, flexShrink: 0 }}>Edit</Typography>
                        </Box>
                      )}
                    </Box>
                  );
                })()} */}

                {/* Share & Copy Profile Link */}
                <Box sx={{ display: 'flex', gap: 1.5, mt: 2, flexWrap: 'wrap' }}>
                  <Button
                    size="small"
                    onClick={() => {
                      const profileIdentifier = userDetails?.profile_id || userDetails?._id || userDetails?.id || userDetails?.userid || userDetails?.user_id || '';
                      const profileUrl = `${window.location.origin}/profile/${encodeURIComponent(profileIdentifier)}`;
                      window.open(profileUrl, '_blank');
                    }}
                    sx={{
                      textTransform: 'none',
                      background: '#21262d',
                      color: '#e5e7eb',
                      borderRadius: '6px',
                      px: 2,
                      fontWeight: 600,
                      border: '1px solid #30363d',
                      gap: '6px',
                      fontSize: '13px',
                      '&:hover': { background: '#30363d' },
                    }}
                  >
                    <OpenInNewIcon sx={{ fontSize: '15px' }} />
                    Share Link
                  </Button>

                  <Button
                    size="small"
                    onClick={() => {
                      const profileIdentifier = userDetails?.profile_id || userDetails?._id || userDetails?.id || userDetails?.userid || userDetails?.user_id || '';
                      const profileUrl = `${window.location.origin}/profile/${encodeURIComponent(profileIdentifier)}`;
                      if (navigator.clipboard && navigator.clipboard.writeText) {
                        navigator.clipboard.writeText(profileUrl).then(() => {
                          toast.success('Profile link copied to clipboard!');
                        }).catch(() => {
                          const el = document.createElement('textarea');
                          el.value = profileUrl;
                          el.style.position = 'fixed';
                          el.style.opacity = '0';
                          document.body.appendChild(el);
                          el.focus();
                          el.select();
                          document.execCommand('copy');
                          document.body.removeChild(el);
                          toast.success('Profile link copied to clipboard!');
                        });
                      } else {
                        const el = document.createElement('textarea');
                        el.value = profileUrl;
                        el.style.position = 'fixed';
                        el.style.opacity = '0';
                        document.body.appendChild(el);
                        el.focus();
                        el.select();
                        document.execCommand('copy');
                        document.body.removeChild(el);
                        toast.success('Profile link copied to clipboard!');
                      }
                    }}
                    sx={{
                      textTransform: 'none',
                      background: '#21262d',
                      color: '#e5e7eb',
                      borderRadius: '6px',
                      px: 2,
                      fontWeight: 600,
                      border: '1px solid #30363d',
                      gap: '6px',
                      fontSize: '13px',
                      '&:hover': { background: '#30363d' },
                    }}
                  >
                    <ContentCopyIcon sx={{ fontSize: '15px' }} />
                    Copy Link
                  </Button>
                </Box>
              </Box>

              {/* Security + Appearance + Data row */}
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ border: '1px solid #21262d', borderRadius: '12px', p: 2.5, backgroundColor: 'transparent', height: '100%' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <Typography sx={{ fontSize: '18px' }}>🔒</Typography>
                      <Box>
                        <Typography fontWeight={600} color="#e5e7eb" variant="subtitle2">Security</Typography>
                        <Typography variant="caption" color="#9ca3af">Manage your password and account security.</Typography>
                      </Box>
                    </Box>
                    
                    <Box
                        onClick={() => {
                          if (isGoogleUser) {
                            toast.error('Password change is not available for accounts signed in with Google.');
                            return;
                          }
                          setShowPasswordModal(true);
                        }}
                        sx={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          py: 1.2,
                          borderBottom: '1px solid #21262d',
                          cursor: isGoogleUser ? 'not-allowed' : 'pointer',
                          opacity: isGoogleUser ? 0.5 : 1,
                          '&:hover': { opacity: isGoogleUser ? 0.5 : 0.8 },
                        }}
                      >
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <Typography sx={{ fontSize: '14px' }}>🔑</Typography>
                          <Box>
                            <Typography variant="body2" color="#e5e7eb" fontWeight={500}>Change Password</Typography>
                            <Typography variant="caption" color="#9ca3af">
                              {isGoogleUser ? 'Not available for Google sign-in accounts' : 'Update your account password'}
                            </Typography>
                          </Box>
                        </Box>
                        {!isGoogleUser && <Typography color="#9ca3af" sx={{ fontSize: '16px' }}>›</Typography>}
                      </Box>

                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, cursor: 'pointer' }} onClick={() => openComingSoon(
                      "Two-Factor Authentication",
                      "This security feature is currently under development and will be available soon."
                    )}>
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <Typography sx={{ fontSize: '14px' }}>🛡️</Typography>
                        <Box>
                          <Typography variant="body2" color="#e5e7eb" fontWeight={500}>Two-Factor Authentication</Typography>
                          <Typography variant="caption" color="#9ca3af">Add an extra layer of security</Typography>
                        </Box>
                      </Box>
                      <Typography color="#9ca3af" sx={{ fontSize: '16px' }}>›</Typography>
                    </Box>
                  </Box>
                </Grid>
                <Grid item xs={12} sm={6}>
                  <Box sx={{ border: '1px solid #21262d', borderRadius: '12px', p: 2.5, backgroundColor: 'transparent', height: '100%', cursor: 'pointer' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                      <Typography sx={{ fontSize: '18px' }}>🎨</Typography>
                      <Box>
                        <Typography fontWeight={600} color="#e5e7eb" variant="subtitle2">Appearance</Typography>
                        <Typography variant="caption" color="#9ca3af">Customize how the platform looks.</Typography>
                      </Box>
                    </Box>
                    <Typography variant="caption" color="#9ca3af" sx={{ display: 'block', mb: 1 }}>Theme — Choose your preferred color theme.</Typography>
                    <Box sx={{ display: 'flex', gap: 1 }}>
                      <Box
                        onClick={() => openComingSoon(
                          "Appearance Settings",
                          "Theme customization is currently under development and will be available soon."
                        )/* handleThemeChange('dark') */}
                        sx={{ flex: 1, border: theme === 'dark' ? '2px solid #3b82f6' : '1px solid #21262d', borderRadius: '8px', p: 1, textAlign: 'center', backgroundColor: 'transparent', cursor: 'pointer' }}
                      >
                        <Box sx={{ height: 32, backgroundColor: '#0d1117', borderRadius: '4px', mb: 0.5 }} />
                        <Typography variant="caption" color={theme === 'dark' ? '#3b82f6' : '#9ca3af'} fontWeight={theme === 'dark' ? 600 : 400}>
                          {theme === 'dark' ? '● Dark' : '○ Dark'}
                        </Typography>
                      </Box>
                      <Box
                        onClick={() => openComingSoon(
                          "Appearance Settings",
                          "Theme customization is currently under development and will be available soon."
                        )/* handleThemeChange('light') */}
                        sx={{ flex: 1, border: theme === 'light' ? '2px solid #3b82f6' : '1px solid #21262d', borderRadius: '8px', p: 1, textAlign: 'center', backgroundColor: 'transparent', cursor: 'pointer' }}
                      >
                        <Box sx={{ height: 32, backgroundColor: '#f3f4f6', borderRadius: '4px', mb: 0.5 }} />
                        <Typography variant="caption" color={theme === 'light' ? '#3b82f6' : '#9ca3af'} fontWeight={theme === 'light' ? 600 : 400}>
                          {theme === 'light' ? '● Light' : '○ Light'}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                  {/* </Box> */}
                </Grid>
              </Grid>

            </Grid>

            {/* ══ RIGHT COLUMN ══ */}
            <Grid item xs={12} md={5} lg={5}>

              {/* Lead Capture */}
              <Box sx={{ border: '1px solid #21262d', borderRadius: '12px', p: 3, mb: 3, backgroundColor: 'transparent' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                  <Typography sx={{ fontSize: '20px' }}>🔽</Typography>
                  <Box>
                    <Typography fontWeight={600} color="#e5e7eb" variant="subtitle1">Lead Capture</Typography>
                    <Typography variant="caption" color="#9ca3af">Manage what information you collect from people who visit your Authority Page or Blog.</Typography>
                  </Box>
                </Box>
                {[
                  { icon: '👤', label: 'Collect Name', sub: "Collect visitor's name", state: collectName, field: 'collect_name', setter: setCollectName },
                  { icon: '✉️', label: 'Collect Email', sub: "Collect visitor's email", state: collectEmail, field: 'collect_email', setter: setCollectEmail },
                  { icon: '🎯', label: 'Collect Source', sub: 'Track where leads came from', state: collectSource, field: 'collect_source', setter: setCollectSource },
                ].map((item, i) => (
                  <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, borderBottom: i < 2 ? '1px solid #21262d' : 'none' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Typography sx={{ fontSize: '16px' }}>{item.icon}</Typography>
                      <Box>
                        <Typography variant="body2" color="#e5e7eb" fontWeight={500}>{item.label}</Typography>
                        <Typography variant="caption" color="#9ca3af">{item.sub}</Typography>
                      </Box>
                    </Box>
                    <Box
                      onClick={() => {
                        const newVal = !item.state;
                        item.setter(newVal);
                        saveToggleSetting(item.field, newVal);
                      }}
                      sx={{ width: 36, height: 20, borderRadius: '10px', backgroundColor: item.state ? '#3b82f6' : '#30363d', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}
                    >
                      <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: '#fff', position: 'absolute', top: 2, transition: 'left 0.2s', left: item.state ? 18 : 2 }} />
                    </Box>
                  </Box>
                ))}
              </Box>

              {/* Notifications */}
              <Box ref={notificationRef} sx={{ border: '1px solid #21262d', borderRadius: '12px', p: 3, mb: 3, backgroundColor: 'transparent' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                  <Typography sx={{ fontSize: '20px' }}>🔔</Typography>
                  <Box>
                    <Typography fontWeight={600} color="#e5e7eb" variant="subtitle1">Notifications</Typography>
                    <Typography variant="caption" color="#9ca3af">Choose what notifications you want to receive.</Typography>
                  </Box>
                </Box>
                {[
                  { icon: '💬', label: 'New message received', sub: 'Instant', state: notifNewMessage, field: 'notif_new_message', setter: setNotifNewMessage },
                  { icon: '👤', label: 'New lead captured', sub: 'Instant', state: notifNewLead, field: 'notif_new_lead', setter: setNotifNewLead },
                  { icon: '📅', label: 'Weekly summary', sub: 'Every Monday', state: notifWeeklySummary, field: 'notif_weekly_summary', setter: setNotifWeeklySummary },
                ].map((item, i) => (
                  <Box key={i} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.2, borderBottom: i < 2 ? '1px solid #21262d' : 'none' }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                      <Typography sx={{ fontSize: '16px' }}>{item.icon}</Typography>
                      <Box>
                        <Typography variant="body2" color="#e5e7eb" fontWeight={500}>{item.label}</Typography>
                        <Typography variant="caption" color="#9ca3af">{item.sub}</Typography>
                      </Box>
                    </Box>
                    <Box
                      onClick={() => {
                        const newVal = !item.state;
                        item.setter(newVal);
                        saveToggleSetting(item.field, newVal);
                      }}
                      sx={{ width: 36, height: 20, borderRadius: '10px', backgroundColor: item.state ? '#3b82f6' : '#30363d', cursor: 'pointer', position: 'relative', transition: 'background 0.2s' }}
                    >
                      <Box sx={{ width: 16, height: 16, borderRadius: '50%', backgroundColor: '#fff', position: 'absolute', top: 2, transition: 'left 0.2s', left: item.state ? 18 : 2 }} />
                    </Box>
                  </Box>
                ))}
                {/*  <Typography variant="caption" onClick={scrollToNotifications} sx={{ color: '#3b82f6', cursor: 'pointer', display: 'block', mt: 1.5 }}>Manage notification preferences →</Typography> */}
              </Box>

              {/* Data & Privacy */}
              <Box sx={{ border: '1px solid #21262d', borderRadius: '12px', p: 3, backgroundColor: 'transparent' }}>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 2 }}>
                  <Typography sx={{ fontSize: '20px' }}>🛡️</Typography>
                  <Box>
                    <Typography fontWeight={600} color="#e5e7eb" variant="subtitle1">Data & Privacy</Typography>
                    <Typography variant="caption" color="#9ca3af">Manage your data and privacy settings.</Typography>
                  </Box>
                </Box>
                <Box
                  onClick={handleExportData}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, borderBottom: '1px solid #21262d', cursor: 'pointer', '&:hover': { opacity: 0.8 } }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography sx={{ fontSize: '16px' }}>📥</Typography>
                    <Box>
                      <Typography variant="body2" color="#e5e7eb" fontWeight={500}>Download your data</Typography>
                      <Typography variant="caption" color="#9ca3af">Export your messages & leads</Typography>
                    </Box>
                  </Box>
                  {exportLoading ? <CircularProgress size={16} sx={{ color: '#9ca3af' }} /> : <Typography color="#9ca3af" sx={{ fontSize: '16px' }}>›</Typography>}
                </Box>
                <Box
                  onClick={() => setShowDeleteConfirm(true)}
                  sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', py: 1.5, cursor: 'pointer', '&:hover': { opacity: 0.8 } }}
                >
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                    <Typography sx={{ fontSize: '16px' }}>🗑️</Typography>
                    <Box>
                      <Typography variant="body2" sx={{ color: '#ef4444' }} fontWeight={500}>Delete account</Typography>
                      <Typography variant="caption" color="#9ca3af">Permanently delete your account</Typography>
                    </Box>
                  </Box>
                  <Typography color="#9ca3af" sx={{ fontSize: '16px' }}>›</Typography>
                </Box>
              </Box>

            </Grid>
          </Grid>

          {/* Train Your Voice section */}
          <Box
            sx={{
              border: '1px solid #21262d',
              borderRadius: '12px',
              p: 3,
              mt: 3,
              backgroundColor: 'transparent',
              display: 'none'
            }}
          >
            <Typography
              color="#ffffff"
              sx={{ fontSize: '18px', fontWeight: 'bold', mb: 1 }}
            >
              Train your voice
            </Typography>

            <Divider sx={{ borderColor: '#21262d', mb: 2 }} />

            <Grid container spacing={2}>

              {/* Voice Name */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="caption"
                  color="#9ca3af"
                  sx={{ mb: 0.5, display: 'block' }}
                >
                  Voice Name
                </Typography>

                <TextField
                  InputProps={{ style: customInputStyle }}
                  sx={{
                    width: '100%',
                    '& .MuiOutlinedInput-root': {
                      backgroundColor: '#0d1117',
                      color: '#fff',
                      borderRadius: '8px',
                      '& fieldset': {
                        borderColor: '#30363d',
                      },
                      '&:hover fieldset': {
                        borderColor: '#3b82f6',
                      },
                      '&.Mui-focused fieldset': {
                        borderColor: '#3b82f6',
                      },
                    },
                  }}
                  type="text"
                  value={voiceName}
                  onChange={(e) => setVoiceName(e.target.value)}
                />
              </Grid>

              {/* Upload Voice Files */}
              <Grid item xs={12} md={6}>
                <Typography
                  variant="caption"
                  color="#9ca3af"
                  sx={{ mb: 0.5, display: 'block' }}
                >
                  Upload Voice Files
                </Typography>

                <input
                  type="file"
                  accept=".wav,audio/wav"
                  multiple
                  onChange={handleFileChange}
                />

                {/* Selected Files */}
                {voiceFiles.length > 0 && (
                  <Box mt={2}>
                    <Typography
                      variant="subtitle2"
                      mb={1}
                      color={voiceFiles.length >= 3 ? "#10b981" : "#9ca3af"}
                    >
                      Selected Files ({voiceFiles.length})
                    </Typography>

                    <Stack direction="row" flexWrap="wrap" gap={1}>
                      {voiceFiles.map((file, index) => (
                        <Chip
                          key={index}
                          label={file.name}
                          onDelete={() =>
                            setVoiceFiles((prev) =>
                              prev.filter((_, i) => i !== index)
                            )
                          }
                          deleteIcon={<CloseIcon />}
                          variant="outlined"
                          sx={{
                            maxWidth: 250,
                            "& .MuiChip-label": {
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                            },
                            "& .MuiChip-deleteIcon": {
                              color: "red",
                              "&:hover": {
                                color: "darkred",
                              },
                            },
                            color: '#9ca3af',
                            backgroundColor: '#161b22',
                            borderColor: '#30363d',
                          }}
                        />
                      ))}
                    </Stack>
                  </Box>
                )}

                {voiceFiles.length > 0 && voiceFiles.length < 3 && (
                  <Typography color="error" variant="caption">
                    Minimum 3 WAV files required
                  </Typography>
                )}
              </Grid>

            </Grid>

            {/* Update Button */}
            <Grid
              container
              style={{
                paddingTop: '1%',
                paddingBottom: '1%',
                display: 'flex',
                justifyContent: 'center'
              }}
            >
              <Grid
                item
                xs={12}
                md={6}
                lg={6}
                style={{
                  display: 'flex',
                  paddingTop: '1%',
                  paddingBottom: '1%'
                }}
              >
                <Button
                  type="submit"
                  variant="contained"
                  sx={{
                    marginRight: '1%',
                    width: '100%',
                    backgroundColor: '#3b82f6',
                    color: '#fff'
                  }}
                >
                  {isLoading ? (
                    <CircularProgress sx={{ color: '#fff' }} />
                  ) : (
                    'Update'
                  )}
                </Button>
              </Grid>
            </Grid>
          </Box>

        </Box>
      </form>

      {/* ── Change Password Modal ── */}
      <Modal open={showPasswordModal} onClose={() => setShowPasswordModal(false)} aria-labelledby="change-password-modal">
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: isMobile ? '95%' : '420px', bgcolor: '#0d1117', border: '1px solid #21262d', borderRadius: '12px', p: 4 }}>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
            <Typography fontWeight={700} color="#e5e7eb" variant="h6">Change Password</Typography>
            <IconButton onClick={() => setShowPasswordModal(false)} sx={{ color: '#9ca3af' }}><CloseIcon /></IconButton>
          </Box>
          <Typography variant="caption" color="#9ca3af" sx={{ display: 'block', mb: 0.5 }}>Current Password</Typography>
          <TextField
            fullWidth
            type="password"
            value={currentPassword}
            onChange={(e) => setCurrentPassword(e.target.value)}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { backgroundColor: '#161b22', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
          />
          <Typography variant="caption" color="#9ca3af" sx={{ display: 'block', mb: 0.5 }}>New Password</Typography>
          <TextField
            fullWidth
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            sx={{ mb: 2, '& .MuiOutlinedInput-root': { backgroundColor: '#161b22', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
          />
          <Typography variant="caption" color="#9ca3af" sx={{ display: 'block', mb: 0.5 }}>Confirm New Password</Typography>
          <TextField
            fullWidth
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            sx={{ mb: 3, '& .MuiOutlinedInput-root': { backgroundColor: '#161b22', color: '#fff', borderRadius: '8px', '& fieldset': { borderColor: '#30363d' }, '&:hover fieldset': { borderColor: '#3b82f6' }, '&.Mui-focused fieldset': { borderColor: '#3b82f6' } } }}
          />
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button fullWidth variant="outlined" onClick={() => setShowPasswordModal(false)} sx={{ borderColor: '#30363d', color: '#9ca3af', borderRadius: '8px' }}>Cancel</Button>
            <Button fullWidth variant="contained" onClick={handleChangePassword} disabled={passwordLoading} sx={{ backgroundColor: '#3b82f6', color: '#fff', borderRadius: '8px' }}>
              {passwordLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Update Password'}
            </Button>
          </Box>
        </Box>
      </Modal>

      {/* ── Delete Account Confirm Modal ── */}
      <Modal open={showDeleteConfirm} onClose={() => setShowDeleteConfirm(false)} aria-labelledby="delete-confirm-modal">
        <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: isMobile ? '95%' : '400px', bgcolor: '#0d1117', border: '1px solid #21262d', borderRadius: '12px', p: 4, textAlign: 'center' }}>
          <Typography sx={{ fontSize: '40px', mb: 1 }}>⚠️</Typography>
          <Typography fontWeight={700} color="#e5e7eb" variant="h6" sx={{ mb: 1 }}>Delete Account?</Typography>
          <Typography variant="body2" color="#9ca3af" sx={{ mb: 3 }}>This action is permanent and cannot be undone. All your data will be deleted.</Typography>
          <Box sx={{ display: 'flex', gap: 2 }}>
            <Button fullWidth variant="outlined" onClick={() => setShowDeleteConfirm(false)} sx={{ borderColor: '#30363d', color: '#9ca3af', borderRadius: '8px' }}>Cancel</Button>
            <Button fullWidth variant="contained" onClick={handleDeleteAccount} disabled={deleteLoading} sx={{ backgroundColor: '#ef4444', color: '#fff', borderRadius: '8px', '&:hover': { backgroundColor: '#dc2626' } }}>
              {deleteLoading ? <CircularProgress size={20} sx={{ color: '#fff' }} /> : 'Delete Account'}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={upgradeModal}
        /* onClose={(event, reason) => {
            if (reason !== "backdropClick") {
                setHelperModal(false);
            }
        }} */
        disableEscapeKeyDown
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <Box
          sx={{
            position: "absolute" as "absolute",
            top: "50%",
            left: "50%",
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            transform: "translate(-50%, -50%)",
            width: isMobile ? "95%" : "40%",
            bgcolor: "background.paper",
            border: "2px solid #000",
            boxShadow: 24,
            pt: 2,
            px: 4,
            pb: 3,
            borderRadius: '15px',
            padding: '3%'
          }}
        >
          <Typography style={{ textAlign: 'center', fontWeight: 'bold' }}><InfoIcon sx={{ color: '#ffcc00' }} /><br />This feature is not included in your plan.  Please upgrade to have access to this feature.</Typography>

          <Stack flexDirection="row" sx={{ display: 'flex', gap: '10px', marginTop: '1%' }}>
            {/* 
                        <Button
                          variant="contained"
                          onClick={() => {
                            const value = {
                              _id: "",
                              product_name: "CodeGenie",
                              product_module: genieSelector.module ? genieSelector.module : "",
                              userid: "",
                              productid: ""
                            };
                            getProduct(value);
                            localStorage.setItem('fromUpgrade', 'true');
                            navigate('/pricing', { state: { campIdFromUpgrade: selectedCampaign, from_page: 'blog_listing' } });
                          }}>
                          Upgrade
                        </Button> */}

            <Button
              onClick={() => setUpgradeModal(false)}
              variant="contained"
            // sx={{ mr: 2, marginTop: '15%' }}
            >
              Close
            </Button>
          </Stack>
        </Box>
      </Modal>

      <ComingSoonPopup
        open={comingSoonOpen}
        onClose={() => setComingSoonOpen(false)}
        title={popupContent.title}
        description={popupContent.description}
      />

    </>
  );
};

export default Usersetting;